import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';


type UseAddPermissionsToCustomRoleForm = () => UseFormReturn;


export const useAddPermissionsToCustomRoleForm: UseAddPermissionsToCustomRoleForm = () => {
  const schema = yup.object().shape({
    permissions: yup.array().of(yup.object().shape({})),
  });

  return useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  })
};
